export enum ETelemetryEvents {
  RecommendationsNotFound = 'recommendations.not-found',
  RecommendationsLoaded = 'recommendations.loaded',
}
